import React from 'react';
import TextInputStyles from './SelectBox.module.css';

const SelectBox = ({ label, name, value, onChange, children, errorMessage, style }) => {
	const fieldName = name || label;
	return (
		<div className={TextInputStyles.text_input}>
			{label && (
				<label htmlFor={fieldName} data-testid='select-component'>
					{label}
				</label>
			)}
			<div className={TextInputStyles.input_box} style={style}>
				{/* <input type={type} placeholder={placeholder} name={label} value={value} onChange={onChange} /> */}
				<select name={fieldName} id={fieldName} value={value} onChange={onChange} data-testid={fieldName}>
					{children}
				</select>
			</div>
			{errorMessage && <p>{errorMessage}</p>}
		</div>
	);
};

export default SelectBox;
